import { IReceiverPart } from '../models/product-detail';
import * as ErrorMessages from './error-messages';

export const required = (errorMessage?: string) => {
    return (text: string | number) => {
        if (
            text && typeof text === 'string'
                ? text.length > 0
                : Number(text) > 0
        ) {
            return null;
        } else {
            return errorMessage ? () => errorMessage : ErrorMessages.isRequired;
        }
    };
};

export const anyRequired = (errorMessage?: string) => {
    return (fieldValue: any) => {
        if (fieldValue != null) {
            return null;
        } else {
            return errorMessage ? () => errorMessage : ErrorMessages.isRequired;
        }
    };
};

export const mustMatch = (
    otherField: string,
    otherFieldLabel: string,
    errorMessage?: string
) => {
    return (text: string, state: any) => {
        return state[otherField] === text
            ? null
            : errorMessage
            ? () => errorMessage
            : ErrorMessages.mustMatch(otherFieldLabel);
    };
};

export const minLength = (length: number, errorMessage?: string) => {
    return (text: string) => {
        return text.length >= length
            ? null
            : errorMessage
            ? () => errorMessage
            : ErrorMessages.minLength(length);
    };
};

export const isEmail = (errorMessage?: string) => {
    return (text: string) => {
        // eslint-disable-next-line no-control-regex
        const reg =
            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (!text || reg.test(text.toLocaleLowerCase())) {
            return null;
        } else {
            return errorMessage ? () => errorMessage : ErrorMessages.isEmail;
        }
    };
};
export const isPhone = (errorMessage?: string) => {
    return (phoneNumber: string) => {
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const valid =
            /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(
                cleaned
            );
        if (!valid) {
            return errorMessage ? () => errorMessage : ErrorMessages.isPhone;
        } else {
            return null;
        }
    };
};

export const minQuantity = (minQuantity: number, errorMessage?: string) => {
    return (quantity: number) => {
        return quantity < minQuantity
            ? errorMessage
                ? () => errorMessage
                : ErrorMessages.minQuantity
            : null;
    };
};

export const maxQuantity = (maxQuantity: number, errorMessage?: string) => {
    return (quantity: number) => {
        return quantity > maxQuantity
            ? errorMessage
                ? () => errorMessage
                : ErrorMessages.maxQuantity
            : null;
    };
};
export const patientRefRegex = (errorMessage?: string) => {
    // eslint-disable-next-line no-useless-escape
    const regexPattern = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?@()._]/g;
    return (patientRef: string) => {
        if (!patientRef || !regexPattern.test(patientRef)) {
            return null;
        } else {
            return errorMessage ? () => errorMessage : ErrorMessages.patientRef;
        }
    };
};
